import './styles/main.scss';

import Alpine from 'alpinejs';

(async () => {
    window.Prism.highlightAll();
    window.Alpine = Alpine;
    Alpine.start();

    /**
     * Back to top button
     */
    document.querySelector("#BackToTopBtn")?.addEventListener("click", () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        const $toggle: HTMLElement | null = document.querySelector("#NavToggle");
        $toggle?.focus();
    });
})();
